import { render, staticRenderFns } from "./StudentRatingIndex.vue?vue&type=template&id=6b8112fc&scoped=true&"
import script from "./StudentRatingIndex.vue?vue&type=script&lang=js&"
export * from "./StudentRatingIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8112fc",
  null
  
)

export default component.exports